const stripTrailingSlash = (url = "") => url.replace(/\/+$/, "");

// URL do app (app.letsdoc.ai). Identidade, onboarding e pagamento vivem lá.
export const APP_URL = stripTrailingSlash(process.env.REACT_APP_APP_URL);

// API do backend. Usada apenas para dados públicos (ex.: GET /billing/planos).
export const API_URL = stripTrailingSlash(process.env.REACT_APP_API_ENDPOINT_BACKEND);

export const WHATSAPP_URL = "https://wa.me/5521995054004";

// Sem APP_URL os links do app viram caminhos relativos e caem no catch-all
// desta landing, sem nenhum erro visível.
if (!APP_URL) {
  console.error("REACT_APP_APP_URL não está definida: os links para o app não vão funcionar.");
}
